<div class="dialog-container">
  <div class="dialog-header flex_sb">
    <div class="dialog-header-title">
      {{ header }}
      <div
        class="fs-16 fw-400 clr-333"
        *ngIf="billingCounterName"
        [innerHTML]="billingCounterInfo"
      ></div>
    </div>
    <div class="dialog-header-cross flex-center" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>
  <div class="dialog-form">
    <div class="sub-header">
      <p class="clr-333 fw-400 fs-14">{{ now | date : 'dd/MM/yyyy, hh:mm a' }}</p>
    </div>
    <form [formGroup]="cashCollectForm">
      <div class="form-container">
        <!-- name field -->
        <div class="form-input-container">
          <label>{{
            'OPEN_CASH_DRAWER.ENTER_STAFF_NAME' | fallbackTranslate | titlecase
          }}</label>
          <input
            type="text"
            placeholder="{{
              'OPEN_CASH_DRAWER.ENTER_HERE' | fallbackTranslate
            }}"
            class="input-name-class m-t-8"
            autocomplete="off"
            formControlName="staff_name"
            [ngClass]="{
              'is-invalid':
                (cashCollectForm.get('staff_name').errors &&
                  cashCollectForm.get('staff_name').touched) ||
                (cashCollectForm.get('staff_name').touched &&
                  cashCollectForm.get('staff_name').hasError('name'))
            }"
          />
          <div class="error-field">
            <div
              class="alert-text"
              *ngIf="
                cashCollectForm.get('staff_name').hasError('required') &&
                cashCollectForm.get('staff_name').touched
              "
            >
              {{ 'OPEN_CASH_DRAWER.REQUIRED' | fallbackTranslate }}
            </div>
          </div>
        </div>
          <!-- Calculator -->
          <div class="form-input-container">
            <label>
              {{
                'OPEN_CASH_DRAWER.ENTER_AMOUNT_IN_RM'
                  | fallbackTranslate
                  | titlecase
              }}
              {{ Currency }})
            </label>
            <input
              type="text"
              placeholder="{{
                'OPEN_CASH_DRAWER.ENTER_HERE' | fallbackTranslate
              }}"
              class="input-name-class m-t-8"
              autocomplete="off"
              formControlName="amount"
              formatInputNumber
              (keypress)="changes($event)"
              [ngClass]="{
                'is-invalid': (cashCollectForm.get('amount')?.invalid &&
                cashCollectForm.get('amount')?.value)||
                  (cashCollectForm.get('amount').errors &&
                    cashCollectForm.get('amount').touched) ||
                  (cashCollectForm.get('amount').touched &&
                    cashCollectForm.get('amount').hasError('name'))
              }"
            />
            <div class="error-field">
              <div
                class="alert-text"
                *ngIf="
                  cashCollectForm.get('amount').hasError('required') &&
                  cashCollectForm.get('amount').touched
                "
              >
                {{ 'OPEN_CASH_DRAWER.REQUIRED' | fallbackTranslate }}
              </div>
              <div
              class="alert-text"
              *ngIf="
                  cashCollectForm.get('amount')?.invalid && cashCollectForm.get('amount')?.value
                "
              >
              {{ 'OPEN_CASH_DRAWER.ENTER_VALID_AMOUNT' | fallbackTranslate }}
              </div>
            </div>
          </div>
          <!-- radio button -->
          <div class="form-input-container">
            <label>{{
              'OPEN_CASH_DRAWER.SELECT_REASON' | fallbackTranslate | titlecase
            }}</label>
            <mat-radio-group
              aria-labelledby="example-radio-group-label"
              class="example-radio-group m-t-8"
              [(ngModel)]="selectedOption"
              [ngModelOptions]="{ standalone: true }"
            >
              <span
                class="example-list-section c-pointer"
                *ngFor="let item of reasons"
                (click)="setRadio(item.id)"
                [ngClass]="
                  selectedOption == item.id ? 'radio-selected-div' : null
                "
              >
                <mat-radio-button
                  class="example-radio-button"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-radio-button>
              </span>
              <span
                class="example-list-section c-pointer"
                (click)="setRadio('custom')"
                [ngClass]="
                  selectedOption == 'custom' ? 'radio-selected-div' : null
                "
              >
                <mat-radio-button class="example-radio-button m-t-8" value="custom">
                  <input
                    [ngClass]="
                      selectedOption == 'custom'
                        ? 'custom-reason-input-active'
                        : null
                    "
                    class="custom-reason-input"
                    type="text"
                    name="reason"
                    id="reason"
                    placeholder="{{
                      'OPEN_CASH_DRAWER.ENTER_A_REASON' | fallbackTranslate
                    }}"
                    [(ngModel)]="reason_text"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </mat-radio-button>
              </span>
            </mat-radio-group>
          </div>
      </div>
    </form>
    <div class="footer">
      <button
        nz-button
        nzSize="large"
        nzType="primary"
        [nzLoading]="isLoading"
        class="success-btn"
        (click)="save_clicked()"
        [disabled]="btnDisabled"
        >
        {{ 'OPEN_CASH_DRAWER.DONE' | fallbackTranslate | uppercase }}
      </button>
    </div>
  </div>
</div>
